// *******************************************************************************
// 1.0 - Range Slider
// *******************************************************************************

const rangeSliderElements = document.querySelectorAll(
  '[data-component="mol-range-slider"] .range-slider__inner .range-slider__input',
);

rangeSliderElements.forEach((el) => {
  const rangeFrom = parseInt(el.getAttribute('data-from'), 10);
  const rangeTo = parseInt(el.getAttribute('data-to'), 10);
  const rangeMinNum = parseInt(el.getAttribute('data-min'), 10);
  const rangeMaxNum = parseInt(el.getAttribute('data-max'), 10);

  const parentEle = el.closest('.range-slider');

  const rangeStartInput = parentEle.querySelector('.range-slider__start-range');

  const rangeEndInput = parentEle.querySelector('.range-slider__end-range');

  const animatedInput = parentEle.querySelector('[data-animated-price-input]');

  const rangeValues = [rangeStartInput, rangeEndInput];

  noUiSlider.create(el, {
    start: [rangeFrom, rangeTo],

    connect: [false, true, false],

    behaviour: 'tap',

    step: 1,

    range: {
      min: rangeMinNum,
      max: rangeMaxNum,
    },

    format: wNumb({
      mark: ',',
      thousand: '.',
      decimals: 0,
      suffix: ' €',
    }),
  });

  el.dispatchEvent(new CustomEvent('rangeSlider:ready', { bubbles: true }));

  el.noUiSlider.on('change', () => {
    el.dispatchEvent(new CustomEvent('rangeSlider:change', { bubbles: true }));
  });

  el.noUiSlider.on('set', () => {
    el.dispatchEvent(new CustomEvent('rangeSlider:set', { bubbles: true }));
  });

  // Update animated input while sliding
  el.noUiSlider.on('slide', (values, handle) => {
    animatedInput?.setAttribute('value', Number(values[handle].replace(/[^\d]/g, '')) || 0);
  });

  // Update text inputs
  el.noUiSlider.on('update', (values, handle) => {
    rangeValues[handle].value = values[handle];
  });

  // Update slider when typing in start input
  rangeStartInput.addEventListener('change', () => {
    el.noUiSlider.set([rangeStartInput.value.replace(/[^\d]/g, ''), null]);
  });

  // Update slider when typing in end input
  rangeEndInput.addEventListener('change', () => {
    el.noUiSlider.set([null, rangeEndInput.value.replace(/[^\d]/g, '')]);
  });
});
